import { Injectable } from '@angular/core';

import { Claim } from '@dav-model/api/response/claims.response';
import { ClaimsFilter, ClaimsFilterDateType, ClaimsFilterStatusType } from '@dav-model/claims-filter';
import { ContractFilterDateType, ContractFilterStatusType } from '@dav-model/history-filter';

import { SortingService } from './sorting.service';
import { EnglishMonthNames, FrenchMonthNames } from "../../static-data/month-names";

@Injectable({
  providedIn: 'root',
})
export class ClaimService {
  static fetchClaimGroup(claims: Claim[]) {
    const language = localStorage.getItem('languageCode');

    const monthNames = language === 'en-US' || language === 'en-CA' ? EnglishMonthNames : FrenchMonthNames;

    return claims
      .reduce((acc, claim) => {
        const date = new Date(claim.dateOfLoss);
        const year = date.getFullYear();
        const month = date.getMonth();

        if (!acc.some((bucket) => bucket.year === year && bucket.month === month)) {
          acc.push({ year, month });
        }

        return acc;
      }, [])
      .sort((a, b) => (b.year - a.year ? b.year - a.year : b.month - a.month))
      .map((bucket) => new ContractFilterDateType(monthNames[bucket.month] + ' ' + bucket.year));
  }

  static fetchStatus(contracts: Claim[]) {
    const status = contracts.reduce((prevVal, elem) => {
      const index = prevVal.some((item) => item.name === elem.status);

      if (!index) {
        prevVal.push(new ContractFilterStatusType(elem.status));
      }

      return prevVal;
    }, []);

    return SortingService.sortStrings(status);
  }

  static fetchClaimFilters(claims: Claim[]) {
    if (claims) {
      const month: ClaimsFilterDateType[] = this.fetchClaimGroup(claims);
      const status: ClaimsFilterStatusType[] = this.fetchStatus(claims);

      return new ClaimsFilter(month, status);
    }
  }

  ////////// STATIC FILTER CONTRACTS ////////////////////////////////////////////////////////
  static filter(filters: ClaimsFilter, claims: Claim[]) {
    const secondLevelFilteredClaims = this.filterByGroup(filters, claims);

    return this.filterByStatus(filters, secondLevelFilteredClaims);
  }

  static filterByGroup(claimsFilter: ClaimsFilter, claims: Claim[]) {
    // get changed claims
    let allClaims = true;

    // Filter claims by claim month
    const filteredClaims = claims.filter((data) => {
      const index = claimsFilter.month.findIndex((x) => x.name === data.claimGroup);
      if (index > -1) {
        // uncheck allClaims button
        if (claimsFilter.month[index].selected) {
          allClaims = false;
        }

        return claimsFilter.month[index].selected;
      } else {
        return true;
      }
    });

    if (allClaims) {
      return claims;
    }

    return filteredClaims;
  }

  static filterByStatus(claimsFilter: ClaimsFilter, claims: Claim[]) {
    // get changed product filters
    let allClaims = true;

    // reset term filter display
    claimsFilter.status.forEach((item, index) => {
      claimsFilter.status[index].display = false;
    });

    // Filter products by status
    const filteredClaims = claims.filter((data) => {
      //  const statusName = this.getStatusName(data.status);
      const index = claimsFilter.status.findIndex((x) => x.name === data.status);
      if (index > -1) {
        // uncheck allProduct button
        if (claimsFilter.status[index].selected) {
          allClaims = false;
        }
        claimsFilter.status[index].display = true;

        return claimsFilter.status[index].selected;
      } else {
        return true;
      }
    });

    if (allClaims) {
      return claims;
    }

    return filteredClaims;
  }
}
